import { ISample, ISourceChannel } from '../models/ichannel';
import { IEcgData } from '../models/iecgdata';

export const ecgDataMapper = (ecgData: any): IEcgData => {
    return {
        sopInstanceUID: ecgData.sopInstanceUID,
        title: ecgData.title,
        patient: ecgData.patient,
        study: ecgData.study,
        filters: ecgData.filters,
        originalWaveform: {
            channels: ecgData.originalWaveform.channels.map((channel: ISourceChannel) => {
                return {
                    samplingFrequency: channel.samplingFrequency,
                    samplingCount: channel.samplingCount,
                    samples: channel.samples.map((value) => {
                        let sample: ISample = {
                            value: value,
                        };
                        return sample;
                    }),
                    annotations: channel.annotations,
                    name: channel.name,
                    type: channel.type,
                    order: channel.order,
                };
            }),
            annotations: ecgData.originalWaveform.annotations,
            filters: ecgData.originalWaveform.filters,
        },
        derivedWaveform: {
            channels: ecgData.derivedWaveform.channels.map((channel: ISourceChannel) => {
                return {
                    samplingFrequency: channel.samplingFrequency,
                    samplingCount: channel.samplingCount,
                    samples: channel.samples.map((value) => {
                        let sample: ISample = {
                            value: value,
                        };
                        return sample;
                    }),
                    annotations: channel.annotations,
                    name: channel.name,
                    type: channel.type,
                    order: channel.order,
                };
            }),
            annotations: ecgData.derivedWaveform.annotations,
            filters: ecgData.derivedWaveform.filters,
        },
    };
};
